<template>
  <div class="footer">
    <div class="footerCol" style="width:1180px;margin:auto;">
      <div>
        <div class="left">
          <div class="footer-logo"><a href="/#/">
            <img
                src="@/assets/bottomlogo.png"
              /></a>
          </div>
          <div class="footer-title">Copyright © 2025 柚优品 版权所有       </div>
          <div class="footer-other" @click="openUrl">
            <img
                src="@/assets/hui.png"
              />
            <label>沪ICP备2025141004号-1</label>
          </div>
        </div>
      </div>
      <div>
        <div class="qr">
          <img
              src="@/assets/ma.jpg"
            />
          <div class="qr-desc">
            <div>关注柚优品公众号</div>
            <div>更多福利等着你</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyFooter',
  
  methods: {
    openUrl() {
      window.open('https://beian.miit.gov.cn', '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
  background-color: #161616;
}
.footerCol {
  padding: 49px 0 45px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.left {
  text-align: left;
  line-height: 27px;
  .footer-logo img {
    width: 118px;
  }
  .footer-title {
    font-size: 16px;
    margin: 40px 0 35px;
  }
  .footer-other {
    justify-items: center;
    display: flex;
    img {
      width: 27px;
      height: 25px;
    }
  }
}
.qr {
  width: 168px;
  text-align: center;
  margin-left: auto;
  img {
    width: 105px;
  }
  .qr-desc {
    font-size: 16px;
  }
}

</style>
